// extracted by mini-css-extract-plugin
export default {"modal":"StripeCancellation_modal__q2sWI","closeButton":"StripeCancellation_closeButton__ROja4","buttons":"StripeCancellation_buttons__Wb02u"};